<template>
  <div class="flex">
    <div class="flex flex-col items-center pt-1 w-[16px] print-hidden">
      <fa
        v-if="startIcon === 'map-marker'"
        icon="map-marker-alt"
      />
      <div
        v-else
        class="h-3 aspect-square bg-white border-4 rounded-full border-black border-solid"
      />

      <div class="grow w-full relative">
        <div class="absolute size-full flex items-center">
          <VerticalDashedLineSVG
            :font-controlled="false"
            filled
            class="h-full text-gray-500/75"
          />
        </div>
      </div>
    </div>

    <div class="w-full px-4 md:pl-3 md:pr-0 px-print-0 flex justify-center h-full flex-col print:mt-10">
      <div
        v-if="itineraryDay.day !== 'x' || itineraryDay.box_type === boxTypes.hotel"
        class="mb-2 product-itinerary__item-title w-full flex justify-between"
        @mouseover="$emit('setMarker', itineraryDay.day)"
        @click="expandAll = true"
      >
        <div class="max-w-[85%]">
          <span
            v-if="hasDay"
            class="font-bold text-nowrap"
          >{{ $t('day') }} {{ itineraryDay.day }}&nbsp;</span>
          <span
            class="font-bold"
            :data-translation="itineraryDay?.title_translationkey"
          >
            {{ itineraryDay.title }}
          </span>
        </div>
        <div
          v-if="itineraryDay.map_points.length > 0 && allowOpenMap"
          class="inline-block cursor-pointer text-blue-800 text-nowrap underline font-semibold font-secondary text-sm print-hidden"
          @click="$emit('openMap', itineraryDay.day)"
        >
          {{ $t('itineraryDay.map') }}
        </div>
      </div>

      <ItineraryContent
        :allow-fullscreen="allowFullscreen"
        :is-destination="isDestination"
        :itinerary-day="itineraryDay"
        @set-marker="$emit('setMarker')"
        @open-map="$emit('openMap')"
      />
    </div>
  </div>
</template>

<script setup>
import VerticalDashedLineSVG from '@packages/icons/vertical-dashed-line.svg'

import { boxTypes } from '@packages/trip/constants/types.ts'

const props = defineProps({
  itineraryDay: {
    type: Object,
    required: true,
  },

  isDestination: {
    type: Boolean,
    default: false,
  },

  allowFullscreen: {
    type: Boolean,
    default: true,
  },

  allowOpenMap: {
    type: Boolean,
    default: true,
  },

  sliderNavigation: {
    type: Boolean,
    default: true,
  },

  textClass: {
    type: String,
    default: '',
  },

  startIcon: {
    type: String,
    default: 'circle',
  },
})

defineEmits(['openMap', 'setMarker'])

const hasDay = computed(
  () => !props.isDestination && props.itineraryDay.day !== '*' && props.itineraryDay.day !== 'x'
)
</script>
